// Module
var code = "<div class=\"brand-tagger\"> <tagger ng-disabled=\"disabled\" placeholder=\"{{placeholder}}\" tags=\"tags\" tag-search-callback=\"model.getBrandTagsAsync(query)\" tracking-action-add-tag=\"{{trackingActionAddTag}}\" tracking-action-remove-tag=\"{{trackingActionRemoveTag}}\" tracking-category=\"{{trackingCategory}}\"> </tagger> </div> ";
// Exports
module.exports = code;